import React, { useEffect } from 'react';

import { get } from '../../../utils/Request';
import { useAuth } from '../../AuthenticationContext';
import { Popup } from '../../../utils/Popup';
import { useConfig } from '../../../ConfigContext';

interface Props {
  children?: JSX.Element | JSX.Element[];
}

interface TwitchUser {
  email: string;
}

interface TwitchResponse {
  data: TwitchUser[],
}

export function TwitchButton(props: Props): JSX.Element {
  const auth = useAuth();
  const config = useConfig();

  const scope = 'user:read:email+openid';

  const nonce = (length: number): string => {
    let text = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < length; i += 1) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  };

  const authUrl = (): string => {
    const url = `${'https://id.twitch.tv/oauth2/authorize'
      + '?client_id='}${config.serverConfig?.providers.twitch.clientId
    }&response_type=token+id_token`
      + '&force_verify=true'
      + '&claims={"id_token":{"email":null,"email_verified":null}}'
      + `&redirect_uri=${window.location.origin}/provider/twitch/redirect`
      + `&scope=${scope}&state=${nonce(15)}&display=popup`;

    return url;
  };

  const displayTwitchPopup = (): void => {
    Popup.open(authUrl(), 'twitch_auth');
  };

  const getDataUser = (tokens: { accessToken: string; idToken: string }): void => {
    get<TwitchResponse>('https://api.twitch.tv/helix/users', {
      headers: {
        'Client-ID': config.serverConfig.providers.twitch.clientId,
        Authorization: `Bearer ${tokens.accessToken}`,
      },
      withCredentials: false,
    })
      .then((res) => {
        if (res.data?.length > 0) {
          const dataUser = res.data[0];
          auth.signinWithProvider({
            idToken: tokens.idToken,
          }, 'twitch', dataUser.email);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const onMessage = (event: MessageEvent): void => {
    if (event.origin === window.location.origin && event.data.accessToken && event.data.idToken) {
      getDataUser(event.data);
    }
  };

  useEffect(() => {
    window.addEventListener('message', onMessage);

    return () => {
      window.removeEventListener('message', onMessage);
    };
  }, []);

  return (
    <button
      type='button'
      id='register-twitch'
      className='btn btn-block btn-outline-light btn-social btn-twitch'
      title='Twitch'
      data-cy='register-twitch-btn'
      onClick={displayTwitchPopup}
    >
      {props.children}
    </button>
  );
}
